import type { ReactElement } from 'react';
import { Box } from '@zoopla-eng/zds-components/box';
import { Stack } from '@zoopla-eng/zds-components/stack';
import { Hero } from '@zoopla-eng/zds-components/hero';
import { styled } from '@zoopla-eng/zds-components/themes';
import { Heading, SearchLabel, SubHeading } from './HousePricesSearch.styles';
import heroShort from './sold@4x.png';

const Img = styled('img', {
    position: 'absolute',
    height: '100%'
});

const HeroShort = ({ children }: { children: ReactElement }) => (
    <Hero bg="$graphicBackgroundContrast" bleed="@S200" bpS200={{ pr: 0 }}>
        <Box display="flex" columnGap="$S500">
            <Box flex={4} bpL100={{ flex: 2 }}>
                <Stack rowGap="$S100">
                    <Box pb="$S300">
                        <Heading>Sold house prices</Heading>
                        <SubHeading>
                            Search house prices by town, road name or postcode
                        </SubHeading>
                    </Box>
                    <SearchLabel htmlFor="location-search">
                        Search area
                    </SearchLabel>
                    {children}
                </Stack>
            </Box>
            <Box
                display="none"
                bpS200={{ display: 'block', flex: 1, position: 'relative' }}
                overflow="hidden"
            >
                <Img src={heroShort} alt="sold sign outline" />
            </Box>
        </Box>
    </Hero>
);

export default HeroShort;
